module.exports = __webpack_public_path__ + "static/media/cka_logo.f00743db.png";